import axios from 'axios';

const metaCsrf = document.querySelector('meta[name="csrf-token"]');
export default axios.create({
  headers: {
    'X-CSRF-Token': metaCsrf ? metaCsrf.getAttribute('content') : null,
  },
});
